import {
  HTTP_LOADBUDGETFA_FETCHING,
  HTTP_LOADBUDGETFA_SUCCESS,
  HTTP_LOADBUDGETFA_FAILED,
  server,
} from "src/Constants";
import Axios from "axios";
import { httpClient } from "src/utils/HttpClient";

//insert Budgets
export const setStateloadBudgetfaToFetching = () => ({
  type: HTTP_LOADBUDGETFA_FETCHING,
});

export const setStateloadBudgetfaToSuccess = (payload) => ({
  type: HTTP_LOADBUDGETFA_SUCCESS,
  payload,
});

export const setStateloadBudgetfaToFailed = (payload) => ({
  type: HTTP_LOADBUDGETFA_FAILED,
});

//update Budgets
// export const setStateupdateProjectToFetching = () => ({
//   type: HTTP_UPDATEPROJECT_FETCHING,
// });

// export const setStateupdateProjectToSuccess = (payload) => ({
//   type: HTTP_UPDATEPROJECT_SUCCESS,
//   payload,
// });

// export const setStateupdateProjectToFailed = (payload) => ({
//   type: HTTP_UPDATEPROJECT_FAILED,
// });

export const loadBudgetfa = (item) => {
  return async (dispatch) => {
    dispatch(setStateloadBudgetfaToFetching());
    try {
      await httpClient.post(`${server.LOADBUDGETFA_URL}`, item);
      dispatch(setStateloadBudgetfaToSuccess("success"));
    } catch (error) {
      dispatch(setStateloadBudgetfaToFailed());
    }
  };
};

// export const updateProjectById = (budgetpid, item) => {
//   return async (dispatch) => {
//     dispatch(setStateupdateProjectToFetching());
//     try {
//       await httpClient.put(`${server.UPDATEPROJECT_URL}/${budgetpid}`, item);
//       dispatch(setStateupdateProjectToSuccess("success"));
//     } catch (error) {
//       dispatch(setStateupdateProjectToFailed());
//     }
//   };
// };
